module.exports = __webpack_public_path__ + "static/img/HanYuan_Banner_spring.2f993ddc.jpg";